// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"3826acb5","86":"da5d543b","240":"c7e62de0","354":"f88db67b","378":"bf0db4ad","610":"6319bdd4","639":"a5372e4d","890":"ad17ea04"}[chunkId] + ".chunk.js";
};